import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    LinearProgress,
    linearProgressClasses,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import React, { useState } from 'react';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    margin: '8px',
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.primary.light,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },
}));

const InputNone = styled('input')(({ theme }) => ({
    display: 'none',
}));

const Degree = props => {
    const { getAccessTokenSilently } = useAuth0();

    const [document, setDocument] = useState({});
    const [status, setStatus] = useState('idle');
    const [isSelected, setIsSelected] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [progress, setProgress] = useState({ loaded: 0, total: 0 });

    const handleSubmission = async () => {
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });

        try {
            if (typeof document.name === 'undefined') {
                throw new Error('No Document Uploaded');
            }
            setStatus('uploading');
            const params = {
                filename: document.name,
                type: 'degree',
                permission: 87,
                size: document.size,
            };
            setProgress({
                loaded: 20,
                total: 100,
            });
            const permission = await axios.post(
                '/uploadDocumentPermissionsAdvanced',
                params,
                {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    timeout: 15000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': document.type,
                    },
                }
            );
            const headers = {
                'Content-Type': document.type,
            };
            console.log(JSON.stringify(permission));
            await axios
                .put(permission.data.uploadURL, document, {
                    timeout: 15000,
                    headers: headers,
                    onUploadProgress: function (progressEvent) {
                        setProgress({
                            loaded: progressEvent.loaded,
                            total: progressEvent.total,
                        });
                    },
                })
                .then(() => {
                    props.clickNextButton();
                });
        } catch (err) {
            console.log(err);
            setStatus('failed');
            if (err.message === 'No Document Uploaded') {
                setErrorMessage(err.message);
            } else {
                setErrorMessage('Failed to upload document');
            }

            setProgress({
                loaded: 0,
                total: 100,
            });
        }
    };

    const fileSelectHandler = event => {
        console.log(event.target.files[0]);
        if (event.target.files[0]) {
            setIsSelected(true);
            setDocument(event.target.files[0]);
        } else {
            setIsSelected(false);
        }
    };

    return (
        <Box sx={{ m: 2 }}>
            <Typography variant="h3" margin="15px">
                Please upload a copy of your degree
            </Typography>
            {isSelected && (
                <Box sx={{ m: 1 }}>
                    <Typography>Name: {document.name}</Typography>
                    <Typography>Size: {document.size / 1000}kb</Typography>
                </Box>
            )}
            {progress.loaded !== 0 && (
                <Box sx={{ width: '100%' }}>
                    <Typography>Progress:</Typography>
                    <BorderLinearProgress
                        variant="determinate"
                        value={(progress.loaded / progress.total) * 100}
                    />
                </Box>
            )}

            <InputNone
                type="file"
                id="contained-button-file"
                onChange={fileSelectHandler}
                data-cy="choose-file"
            />
            <label htmlFor="contained-button-file">
                <Button
                    color="secondary"
                    variant="outlined"
                    component="span"
                    sx={{ marginRight: '16px' }}
                >
                    Choose file
                </Button>
            </label>
            <Button
                color="primary"
                variant="outlined"
                component="span"
                onClick={handleSubmission}
                disabled={progress.loaded !== 0}
                data-cy="submit"
            >
                Submit Document
            </Button>
            {status === 'failed' && (
                <Typography color="error">{errorMessage}</Typography>
            )}
        </Box>
    );
};

export default Degree;
